<template>
  <div id="root" :class="['main-container', { 'show-outline': showOut }]">
    <!-- 登陆后视图 -->
    <template v-if="hasToken">
      <!-- 左侧菜单区 -->
      <the-menu class="main-menu-box" />
      <!-- 右侧视图 -->
      <div class="main-container-content">
        <!-- 上部导航区 -->
        <the-nav @checkThis="openDialog" ref="thenav" />
        <notify-msg v-if="showOut" @logExit="logExit"></notify-msg>
        <!-- 子应用渲染区 -->
        <div class="main-container-view">
          <el-scrollbar class="wl-scroll">
            <div v-if="appLoading" class="subapp-loading"></div>
            <div id="subapp-viewport" class="app-view-box"></div>
            <div v-if="showCopyright" class="copyright">
              Copyright© 京东方科技集团股份有限公司版权所有
            </div>
          </el-scrollbar>
          <div style="background-color: #eee"></div>
        </div>
        <!-- AI弹框  @mouseenter="(e) => (e.target.style.right = '10px')" @mouseleave="(e) => (e.target.style.right = '-20px')" -->
        <div
          class="home-aibox__g"
          style="
            background-image: linear-gradient(180deg, #1296f6 0%, #1564f7 100%);
            border: 1px solid rgba(255, 255, 255, 1);
          "
          @click="openAIWindow()"
        >
          <img
            src="./assets/jiqiren.png"
            style="width: 20px; margin-bottom: 5px"
          />
          <span style="display: inline-block; width: 30px; text-align: center"
            >智能助手</span
          >
        </div>
        <!-- 公共弹窗渲染区 -->
        <el-dialog
          :title="$t('i18n_change_pwd')"
          :visible.sync="resetPassword"
          width="30%"
          @close="closeDialog"
          :before-close="handleClose"
          :close-on-click-modal="false"
        >
          <el-form
            v-if="reloadForm"
            ref="form"
            :model="form"
            :rules="localeLanguage === 'zh_cn' ? loginRules : loginRules2"
            :label-width="localeLanguage === 'zh_cn' ? ' 100px' : '135px'"
          >
            <el-form-item :label="$t('i18n_old_pwd')" prop="oldPassword">
              <el-input v-model="form.oldPassword" :type="passwordType">
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showPassword"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_new_pwd')" prop="newPassword">
              <el-input v-model="form.newPassword" :type="newPasswordType">
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showNewPassword"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_confirm_pwd')" prop="confrmPassword">
              <el-input
                v-model="form.confrmPassword"
                :type="confrmPasswordType"
              >
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showConfrmPassword"
                ></i>
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible">{{
              $t("i18n_Cancel")
            }}</el-button>
            <el-button type="primary" @click="handleNewPassword">{{
              $t("i18n_confirm")
            }}</el-button>
          </span>
        </el-dialog>
      </div>
    </template>

    <div v-else-if="resetCode">
      <el-dialog
        :title="$t('i18n_enter_new_pwd')"
        :visible="true"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <el-form
          ref="resetform"
          :model="form"
          :rules="resetRules"
          :label-width="localeLanguage === 'zh_cn' ? ' 100px' : '135px'"
        >
          <el-form-item :label="$t('i18n_new_pwd')" prop="newPassword">
            <el-input v-model="form.newPassword" :type="newPasswordType">
              <i
                class="el-icon-view el-input__icon"
                slot="suffix"
                @click="showNewPassword"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('i18n_confirm_pwd')" prop="confrmPassword">
            <el-input v-model="form.confrmPassword" :type="confrmPasswordType">
              <i
                class="el-icon-view el-input__icon"
                slot="suffix"
                @click="showConfrmPassword"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible">{{ $t("i18n_Cancel") }}</el-button>
          <el-button type="primary" @click="handleForgotPassword">{{
            $t("i18n_confirm")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 非登录视图 -->
    <div v-else id="subapp-viewport" class="app-view-box"></div>
  </div>
</template>
<script>
import TheMenu from "@/components/TheMenu.vue";
import TheNav from "@/components/TheNav.vue";
import NotifyMsg from "@/components/NotifyMsg.vue";
import { mapGetters } from "vuex"; // 引入状态共享
import { resetPassword, getPasswordRule } from "@/api/common";
import { setStore, getStore } from "./util/store";
import PWDRULE from "./util/passwordRule";
import CryptoJS from "crypto-js";
// import { setup } from '../locales'
export default {
  name: "rootView",
  components: {
    TheMenu,
    TheNav,
    NotifyMsg,
  },
  props: {
    loading: Boolean,
    appContent: String,
  },
  watch: {
    appLoading:{
      handler(val){
        setTimeout(() => {
          this.showCopyright = !val;
        }, 2000);
      },
    },
    hasToken: {
      handler(val) {
        // eslint-disable-next-line no-debugger
        if (val) {
          this.listenPage();
        } else {
          window.myTimer && this.clearTimer();
        }
      },
      deep: true,
    },
  },
  data() {
    const validateNewpass = (rule, value, callback) => {
      let res = /^\s+|\s+|\s+$/g;
      if (res.test(value)) {
        callback(new Error(this.$t("i18n_pwd_cant_contain_spaces")));
      } else {
        callback();
      }
    };
    return {
      showCopyright: false,
      form: {},
      count: 0,
      reloadForm: true,
      showOut: false, // 是否开启退出倒计时
      localeLanguage: window.localStorage.getItem("localeLanguage"),
      loginRules: {
        oldPassword: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("i18n_enter_old_pwd"),
          },
        ],
        confrmPassword: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("i18n_enter_confirm_pwd"),
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("i18n_enter_new_pwd"),
            trigger: "blur",
          },
          {
            trigger: "blur",
            validator: validateNewpass,
          },
        ],
      },
      loginRules2: {
        oldPassword: [
          {
            required: true,
            trigger: "blur",
            message: "Please enter the old password",
          },
        ],
        confrmPassword: [
          {
            required: true,
            trigger: "blur",
            message: "Please enter a new password",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "Please enter the confirmation password",
            trigger: "blur",
          },
          {
            trigger: "blur",
            validator: validateNewpass,
          },
        ],
      },
      resetRules: {
        confrmPassword: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("i18n_enter_confirm_pwd"),
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("i18n_enter_new_pwd"),
            trigger: "blur",
          },
          {
            trigger: "blur",
            validator: validateNewpass,
          },
        ],
      },
      isStaff: true,
      passwordType: "password",
      newPasswordType: "password",
      confrmPasswordType: "password",
    };
  },
  created() {
    this.getPasswordRule();
  },
  methods: {
    listenPage() {
      // 监听鼠标
      document.onmousemove = (event) => {
        let x1 = event.clientX;
        let y1 = event.clientY;
        if (this.x !== x1 || this.y !== y1) {
          this.count = 0;
          this.showOut = false;
        }
        this.x = x1;
        this.y = y1;
      };
      // 监听键盘
      document.onkeydown = () => {
        this.count = 0;
        this.showOut = false;
      };
      // 监听Scroll
      document.onscroll = () => {
        this.count = 0;
        this.showOut = false;
      };
      this.setTimer();
    },
    clearTimer() {
      clearInterval(window.myTimer);
      window.myTimer = null;
    },
    setTimer() {
      this.count = 0;
      if (!window.myTimer) {
        window.myTimer = window.setInterval(this.cookieTimeout, 60000);
      }
    },
    cookieTimeout() {
      // 判断用户30分钟无操作就自动登出
      this.count++;
      if (this.count === 30) {
        this.showOut = true;
        console.log("30分钟未操作，请重新登录");
        // alert('您已30分钟未操作，请重新登录');
        this.logExit();
      }
    },
    // 退出系统
    logExit() {
      this.$store.dispatch("app/setCode", "");
      this.$refs.thenav.logOut();
    },
    dialogVisible() {
      this.form = {};
      this.handleClose();
    },
    openDialog() {
      this.localeLanguage = window.localStorage.getItem("localeLanguage");
      this.reloadForm = true;
    },
    closeDialog() {
      this.form = {};
      this.reloadForm = false;
    },
    showPassword() {
      this.passwordType === "text"
        ? (this.passwordType = "password")
        : (this.passwordType = "text");
    },
    showNewPassword() {
      this.newPasswordType === "text"
        ? (this.newPasswordType = "password")
        : (this.newPasswordType = "text");
    },
    showConfrmPassword() {
      this.confrmPasswordType === "text"
        ? (this.confrmPasswordType = "password")
        : (this.confrmPasswordType = "text");
    },
    getPasswordRule() {
      const existRule = getStore({ name: "passwordRule", timer: 1200 });
      if (existRule) {
        this.passwordRule = existRule;
        PWDRULE.handerRuleSet(existRule, this.loginRules);
        PWDRULE.handerRuleSet(existRule, this.resetRules);
        return true;
      }
      getPasswordRule().then((res) => {
        if (res.code === 200) {
          const passwordRule = res.data;
          this.passwordRule = res.data;
          PWDRULE.handerRuleSet(passwordRule, this.loginRules);
          PWDRULE.handerRuleSet(passwordRule, this.resetRules);
          setStore({ name: "passwordRule", content: passwordRule });
        }
      });
    },
    handleForgotPassword() {
      if (this.form.confrmPassword !== this.form.newPassword) {
        this.$message({
          message: "新密码和确认密码不一致，请重新输入",
          type: "error",
          showClose: true,
        });
        return;
      }
      const data = {
        // password: window.hex_sha1(window.hex_md5(this.form.confrmPassword)),
        password: this.encrypt(
          this.form.confrmPassword,
          "abcdef0123456789",
          "abcdef0123456789"
        ),
        code: this.resetCode,
      };
      const features = "/srm-system/personnel/resetPwdByCode";
      this.$refs.resetform.validate((valid) => {
        if (valid) {
          resetPassword(features, data).then((res) => {
            if (res && res.code === 200) {
              this.$message({
                message: "修改成功，请用新密码重新登录",
                type: "success",
              });
              this.$store.dispatch("app/setPassword", false);
              location.href = "/";
            } else {
              this.$message({
                message: res.msg,
                type: "error",
                showClose: true,
              });
            }
            //
          });
        }
      });
    },
    handleNewPassword() {
      if (this.form.confrmPassword !== this.form.newPassword) {
        this.$message({
          message: "新密码和确认密码不一致，请重新输入",
          type: "error",
          showClose: true,
        });
        return;
      }
      let confrmPassword = "";
      let oldPassword = "";
      // confrmPassword = window.hex_sha1(
      //   window.hex_md5(this.form.confrmPassword)
      // );
      confrmPassword = this.encrypt(
        this.form.confrmPassword,
        "abcdef0123456789",
        "abcdef0123456789"
      );
      // oldPassword = window.hex_sha1(window.hex_md5(this.form.oldPassword));
      oldPassword = this.encrypt(
        this.form.oldPassword,
        "abcdef0123456789",
        "abcdef0123456789"
      );
      const data = {
        password: confrmPassword,
        updatePassword: oldPassword,
      };

      const features = "/srm-system/personnel/resetPwd";
      this.$refs.form.validate((valid) => {
        if (valid) {
          resetPassword(features, data).then((res) => {
            if (res && res.code === 200) {
              this.$message({
                message: "修改成功，请用新密码重新登录",
                type: "success",
              });
              this.$store.dispatch("app/setPassword", false);
              //this.form= {};
              this.form = {};
            } else {
              this.$message({
                message: res.msg,
                type: "error",
                showClose: true,
              });
            }
            //
          });
        }
      });
    },
    handleClose() {
      this.$store.dispatch("app/setPassword", false);
    },
    encrypt(str, strKey, strIv) {
      let key = CryptoJS.enc.Utf8.parse(strKey);
      let iv = CryptoJS.enc.Utf8.parse(strIv);
      let encrypted = "";
      let srcs = CryptoJS.enc.Utf8.parse(str);
      encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    openAIWindow() {
      const userInfoStr = sessionStorage.getItem("userInfo");
      if (userInfoStr) {
        // let url = window.location.origin + '/vendor/vendor-static';
        // if(url.includes('localhost')) {
        //   url = 'http://localhost:6004'
        // }
        const content = JSON.parse(userInfoStr).content;
        const userCode = content ? content.user_code : "";
        let boeToken = content ? content.user_center_token : "";
        const newWindow = window.open(
          // url + '/aiTalk.html?code=yiha',
          `https://bps.boe.com.cn/chat/modelService?channel=01K9REWTZFGQ4MZ04TFQD4N6GB&workspaceId=0&userCode=${userCode}&boeToken=${boeToken}#toolbar=0`,
          "SRM智能对话",
          "height=700,width=1000,top=200,left=500,toolbar=no,menubar=no, scrollbars=no,resizable=no,location=no, status=no, titlebar=no"
        );
        setTimeout(() => {
          if (newWindow && !newWindow.closed) {
            newWindow.document.title = "SRM智能对话";
          }
        }, 1000);
      } else {
        this.$message.error("当前登录失效，请重新登录！");
      }
    },
  },
  computed: {
    hasToken() {
      return !!this.$store.getters.token;
    },
    ...mapGetters(["appLoading", "resetPassword", "resetCode"]),
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
.main-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.show-outline {
  border: 3px solid orange;
  animation: showWarning 2s infinite;
}
@keyframes showWarning {
  0% {
    border-color: orange;
  }
  50% {
    border-color: transparent;
  }
  100% {
    border-color: orange;
  }
}
.main-container-content {
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  > .main-container-view {
    flex: 1;
    position: static;
    padding: 12px 12px 0 12px;
    width: 100%;
    height: calc(100% - 106px);
    background: $main-base-color;
    box-sizing: border-box;
    > .wl-scroll {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      .el-scrollbar__wrap {
        overflow-x: hidden;
        .el-scrollbar__view {
          padding: 8px 8px 0 8px;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .app-view-box {
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      // padding: 0;
      // box-sizing: border-box;
      // min-height: 90vh;
    }
  }
}
.subapp-loading {
  background: url("~@/assets/images/loading.gif");
  background-size: 30%;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
  height: 100%;
  width: 100%;
  margin: auto;
}
.avue-main {
  padding-bottom: 10px !important;
}
.copyright {
  text-align: center;
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  height: 40px;
  width: 100%;
  position: static;
  // background-color: #EFF2FC;
  display: flex;
  align-items: center;
  justify-content: center;
}
// .app-view-box {
//   box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
// }
// @media screen and (min-width:1920px) {
//   .app-view-box{
//     width: calc(1920px - 230px);
//     margin: 0 auto;
//     overflow: hidden;
//   }
// }
.home-aibox__g {
  position: absolute;
  right: 5px;
  top: 410px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 5px;
  border-radius: 24px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 0px 8px 0px rgba(66, 104, 230, 0.3);
  height: 91px;
  width: 48px;
  &:hover {
    box-shadow: 0 0px 8px 0px rgba(66, 104, 230, 0.7);
  }
}
</style>
